import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { InvitedModel } from 'common/models/page-models/Invited Students Model/invited-grid-data.model';
import { InvitedListingModel } from 'common/models/page-models/Invited Students Model/invited-grid-params.model';

import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { AssignmentGridWidgetService } from 'common/widget/assignment/assignment-grid-widget.service';
import { InvitedGridWidgetService } from 'common/widget/assignment/invited-grid-widget.service';


@Injectable({
    providedIn: 'root'
})
export class InvitedGridResolver extends GridResolver<InvitedModel, InvitedListingModel> {
    constructor(
        protected fs: InvitedGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);

    }


}
